import type { RangeValue } from '@morpho-org/ui-v6/client'

export interface BaseMasterFilterState {
  assets: string[]
  curators: string[]
  collateralExposure: string[]
  collateralExclusion: string[]
  deposits: RangeValue
  liquidity: RangeValue
  apy: RangeValue
}

export const DEFAULT_BASE_MASTER_FILTER_STATE: BaseMasterFilterState = {
  assets: [],
  curators: [],
  collateralExposure: [],
  collateralExclusion: [],
  deposits: {},
  liquidity: {},
  apy: {}
}

interface BaseUrlParams {
  assets: string[]
  curators: string[]
  collateralExposure: string[]
  collateralExclusion: string[]
  totalAssetsUsd_gte: number | null
  totalAssetsUsd_lte: number | null
  liquidityUsd_gte: number | null
  liquidityUsd_lte: number | null
  netApy_gte: number | null
  netApy_lte: number | null
}

export function baseUrlParamsToState(params: BaseUrlParams): BaseMasterFilterState {
  return {
    assets: params.assets,
    curators: params.curators,
    collateralExposure: params.collateralExposure,
    collateralExclusion: params.collateralExclusion,
    deposits: {
      min: params.totalAssetsUsd_gte ?? undefined,
      max: params.totalAssetsUsd_lte ?? undefined
    },
    liquidity: {
      min: params.liquidityUsd_gte ?? undefined,
      max: params.liquidityUsd_lte ?? undefined
    },
    apy: {
      min: params.netApy_gte ?? undefined,
      max: params.netApy_lte ?? undefined
    }
  }
}

export function baseStateToUrlParams(state: BaseMasterFilterState): BaseUrlParams {
  return {
    assets: state.assets,
    curators: state.curators,
    collateralExposure: state.collateralExposure,
    collateralExclusion: state.collateralExclusion,
    totalAssetsUsd_gte: state.deposits.min ?? null,
    totalAssetsUsd_lte: state.deposits.max ?? null,
    liquidityUsd_gte: state.liquidity.min ?? null,
    liquidityUsd_lte: state.liquidity.max ?? null,
    netApy_gte: state.apy.min ?? null,
    netApy_lte: state.apy.max ?? null
  }
}
